import { render, staticRenderFns } from "./AcademiesList.vue?vue&type=template&id=ba6dc5fc&scoped=true&"
import script from "./AcademiesList.vue?vue&type=script&lang=js&"
export * from "./AcademiesList.vue?vue&type=script&lang=js&"
import style0 from "./AcademiesList.vue?vue&type=style&index=0&id=ba6dc5fc&scoped=true&lang=scss&"
import style1 from "./AcademiesList.vue?vue&type=style&index=1&id=ba6dc5fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6dc5fc",
  null
  
)

export default component.exports